import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const swiper = new Swiper('.js-with-us-work__slider .swiper', {
	slidesPerView: 'auto',
	breakpoints: {
		// when window width is >= 1172px
		1172: {
			slidesPerGroup: 5,
		},
	},
	navigation: {
		prevEl: '.js-with-us-work__arrow-prev',
		nextEl: '.js-with-us-work__arrow-next',
	},
	modules: [Navigation],
});
